import { RootState } from '@/App/store';

export const selectRegister = (state: RootState) => state.register;
